import $axios from '@/plugins/axios-instance'

export default {
    state: {
        vacancy: []
    },
    getters: {
        getVacancy(state) {
            return state.vacancy
        }
    },
    actions: {
        vacancyGet(context) {
            return  $axios.get(`/vacancy/Get`)
            .then((response) => {
                context.state.vacancy = response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        vacancyDetails(context, data) {
            return  $axios.get(`/vacancy/Details?id=${data.id}`)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        vacancyCreate(context, data) {
            return $axios.post('/vacancy/Create', data)
            .then((response) => {
                context.state.vacancy.push(response.data)
            }).catch((e)=>{
                throw(e.response)
            })
        },

        vacancyEdit(context, data) {
            return $axios.post('/vacancy/Edit', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        vacancyDelete(context, data) {
            return $axios.delete(`/Vacancy/Delete/${data.id}`)
            .then((response) => {
                context.state.vacancy.splice(data.index, 1)
            }).catch((e)=>{
                throw(e.response)
            })
        },


    }
}